import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { getPrerenderParams } from '../blog.routes';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-blog-detail',
  standalone: true,
  imports: [CommonModule, HttpClientModule, MarkdownModule, TranslateModule],
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.scss'],
})
export class BlogDetailComponent implements OnInit {
  markdownContent = '';
  slugList: string[] = [];
  currentIndex = 0;

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router) {}

  async ngOnInit() {
    const params = await getPrerenderParams();
    this.slugList = params.map((p) => p['slug']);

    this.route.paramMap.subscribe((params) => {
      const slug = params.get('slug')!;
      this.currentIndex = this.slugList.indexOf(slug);
      this.loadMarkdown(slug);
    });
  }

  loadMarkdown(slug: string) {
    this.http
      .get(`${slug}.md`, { responseType: 'text' })
      .subscribe((md) => (this.markdownContent = md || 'Beitrag nicht gefunden.'));
  }

  get hasPrev() {
    return this.currentIndex > 0;
  }

  get hasNext() {
    return this.currentIndex < this.slugList.length - 1;
  }

  goTo(offset: number) {
    const newSlug = this.slugList[this.currentIndex + offset];
    this.router.navigate(['/blog', newSlug]).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });  }
}
